<template>
  <div class="maintainMask" v-if="showMaintain">
    <div>
      <span>{{ desc }}</span>
    </div>
  </div>
</template>

<script>
import { checkStatus } from '@/services/exam';
export default {
  data() {
    return {
      showMaintain: false
    }
  },
  props: {
    desc: {
      type: String,
      default: '正在维护中…'
    },
    subjectGroup: {
      type: [String, Number],
      default: undefined
    },
  },
  methods: {
    async checkStatus() {
      const res = await checkStatus({
        subject_group: this.subjectGroup
      })
      if (res.code === 200) {
        if (this.subjectGroup) {
          this.showMaintain = !res.data.is_exam
        } else {
          this.showMaintain = !res.data.is_open
        }
      }
    }
  },
  mounted () {
    this.checkStatus()
  }
}

</script>

<style scoped lang="less">
.maintainMask{
  position: fixed;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 99999;
  > div{
    width: 371px;
    height: 232px;
    background-color: #fff;
    border-radius: 10px;
    text-align: center;
    background-image: url('~@/assets/images/maskImg.png');
    background-size: contain;
    background-position-x: center;
    background-repeat: no-repeat;
    > span{
      font-size: 16px;
      font-weight: bold;
      color: #000000;
      line-height: 22px;
      padding-top: 178px;
      display: block;
    }
  }
}
</style>
